import { ErrorMessages } from "../../tgccGlobal";

/**
 * Returns a shared heading for common estimate-related error messages.
 * Component-specific error mappings should be handled by the caller before
 * falling back to this helper.
 *
 * Returns `null` when no shared heading applies so callers can decide on
 * their own default headings.
 */
export const getSharedEstimateErrorHeading = (errorMessage: string | null): string | null => {
    if (!errorMessage) {
        return null;
    }

    // Estimate already processed
    if (errorMessage === ErrorMessages.ESTIMATE_ALREADY_PROCESSED.message) {
        return ErrorMessages.ESTIMATE_ALREADY_PROCESSED.heading;
    }

    // Generic submission error
    if (errorMessage === "We encountered an issue submitting your request. Please try again in a moment.") {
        return "Submission Error";
    }

    // Estimate was changed by account manager (from API)
    if (
        errorMessage.includes("changed by your account manager") &&
        errorMessage.includes("can no longer be approved")
    ) {
        return "Estimate Updated";
    }

    return null;
};

